import { makeStyles } from '@material-ui/core';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';
import Box from '@mui/material/Box';

import { useEditPageContext } from 'components/shared/CRUD/components/InnerPage/EditPage';
import { renderColorReadMode } from 'components/shared/CRUD/components/InnerPage/components/readMode/readModeRenderers';
import withReadModeField from 'components/shared/CRUD/components/InnerPage/components/withReadModeField';

import { getBrCategoryOptions, getBrTypeOptions } from 'queries';
import { ControlledSelect } from 'components/shared';
import { Option } from 'components/shared/ControlledFields/ControlledSelect';
import {
  ColorField,
  PrivilegedEmailField,
  RequestExcludeField,
  SortOrderField
} from '../fields/BaseFields';

const SelectField = (props) => {
  return <ControlledSelect {...props} variant="outlined" />;
};

const TypeFieldWithReadMode = withReadModeField(SelectField);
const CategoryFieldWithReadMode = withReadModeField(SelectField);
const SortOrderFieldWithReadMode = withReadModeField(SortOrderField);
const ColorFieldWithReadMode = withReadModeField(ColorField);
const PrivilegedEmailFieldWithReadMode =
  withReadModeField(PrivilegedEmailField);

const useStyles = makeStyles(() => ({
  root: {
    flexDirection: 'column',
    flex: 1
  }
}));

const PlanUnitFormFields = () => {
  const { isEditable } = useEditPageContext();
  const { t } = useTranslation('common');
  const classes = useStyles();
  const { control } = useFormContext();

  const { data: brTypeOptions } = getBrTypeOptions();
  const { data: brCategoryOptions } = getBrCategoryOptions();

  return (
    <Box display="flex" className={classes.root}>
      <Box mb={2.5} sx={{ width: '100%' }}>
        <Grid container mb={2.5} rowSpacing={2} columnSpacing={2}>
          <Grid xs={6} item={true}>
            <TypeFieldWithReadMode
              label={t('costCenters.grid.type')}
              name="type"
              control={control}
              options={brTypeOptions as Option[]}
              valueGetter="value"
              labelGetter="label"
            />
          </Grid>

          <Grid xs={6} item>
            <CategoryFieldWithReadMode
              label={t('costCenters.grid.category')}
              name="category"
              control={control}
              options={[
                {
                  value: '',
                  label: t('costCenters.grid.none')
                },
                ...(brCategoryOptions as Option[])
              ]}
              valueGetter="value"
              labelGetter="label"
            />
          </Grid>

          <Grid xs={6} item>
            <PrivilegedEmailFieldWithReadMode
              name="privilegedEmailAddress"
              label={t('costCenters.grid.privilegedEmailAddress')}
            />
          </Grid>

          <Grid xs={6} item>
            <RequestExcludeField disabled={!isEditable} />
          </Grid>

          <Grid xs={6} item>
            <ColorFieldWithReadMode
              label={t('color')}
              name="colorCode"
              readModeRenderer={(props) =>
                renderColorReadMode({
                  ...props
                })
              }
            />
          </Grid>

          <Grid xs={6} item>
            <SortOrderFieldWithReadMode
              name="sortOrderAgency"
              label={t('costCenters.grid.sortOrderAgency')}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default PlanUnitFormFields;
